import {Item} from '@radix-ui/react-toggle-group';
import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

import type {IconProp} from '@fortawesome/fontawesome-svg-core';

type Props = React.ComponentPropsWithRef<typeof Item> & {
  title: string;
  icon: IconProp;
};
export const ToggleGroupIconButton = ({
  ref,
  className,
  icon,
  ...props
}: Props) => {
  return (
    <Item
      {...props}
      ref={ref}
      className={clsx(
        'bg-slate1 text-slate12 ring-slate6 hover:bg-slate3 focus-visible:bg-slate3 disabled:bg-slate2 disabled:text-slate11 radix-state-on:z-10 radix-state-on:bg-blue5 radix-state-on:ring-blue8 relative inline-flex items-center justify-center px-2 py-2 text-sm font-semibold ring-1 ring-inset focus-visible:z-10 focus-visible:outline-hidden',
        className
      )}
    >
      <span className="sr-only">{props.title}</span>
      <Icon icon={icon} aria-hidden="true" />
    </Item>
  );
};

ToggleGroupIconButton.displayName = 'ToggleGroupIconButton';
